/*
 * assets/js/src/snehulak.js — sněhulák u tlačítka zimního formuláře (dev.16.55).
 *
 * Majitel 23. 10. 2026 21:45 (hub Novoroční detox): sněhulák u tlačítka
 * „Nezávazně poptat akci" je smyčka videa s průhledností (Kling, VP9 alpha),
 * markup `template-parts/form-zima-2026.php`.
 *
 * VÝCHOZÍ STAV JE OBRÁZEK (`.snehulak-i`). Modul video zapne, až když:
 *  1. formulář dojede k výřezu (IntersectionObserver, rezerva 300 px) —
 *     0,66 MB se nestahuje lidem, kteří k formuláři nedojedou;
 *  2. první snímek má v rohu průhledný pixel. Safari WebM/VP9 přehraje,
 *     ale alfu zahodí (černý obdélník kolem sněhuláka), a `canPlayType`
 *     to nepozná — proto se snímek nakreslí do plátna 4 × 4 a čte se alfa.
 * Pak dostane obal `.hraje`, CSS prohodí obrázek za video a video hraje.
 * Chyba načtení = zůstane obrázek.
 *
 * `prefers-reduced-motion: reduce` = modul nic nedělá (obrázek stojí).
 */

const SEL = '.formsec.zima .snehulak';

/**
 * Má první snímek průhlednost? (levý horní roh je v návrhu prázdný)
 *
 * @param {HTMLVideoElement} v Video.
 * @returns {boolean}
 */
function maAlfu(v) {
	try {
		const c = document.createElement('canvas');
		c.width = 4;
		c.height = 4;
		const ctx = c.getContext('2d');
		if (!ctx) {
			return false;
		}
		ctx.drawImage(v, 0, 0, 4, 4, 0, 0, 4, 4);
		return ctx.getImageData(1, 1, 1, 1).data[3] < 128;
	} catch (chyba) {
		// Snímek ještě není nebo plátno nejde číst: zůstane obrázek.
		window.console.debug('snehulak: bez alfy', chyba);
		return false;
	}
}

/**
 * Načte a případně spustí video jednoho sněhuláka.
 *
 * @param {Element} obal Prvek `.snehulak`.
 */
function spust(obal) {
	const v = obal.querySelector('video.snehulak-v');
	if (!v) {
		return;
	}
	v.addEventListener(
		'loadeddata',
		() => {
			if (!maAlfu(v)) {
				return;
			}
			obal.classList.add('hraje');
			const hrani = v.play();
			if (hrani && typeof hrani.catch === 'function') {
				hrani.catch(() => obal.classList.remove('hraje'));
			}
		},
		{ once: true }
	);
	v.preload = 'auto';
	v.load();
}

/**
 * Spustí modul. Vrací počet sněhuláků.
 *
 * @returns {number}
 */
export function init() {
	const obaly = document.querySelectorAll(SEL);
	if (!obaly.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
		return 0;
	}
	let count = 0;
	for (const obal of obaly) {
		if (obal.dataset.zaSnehulakInit === '1') {
			continue;
		}
		obal.dataset.zaSnehulakInit = '1';
		count += 1;
		if (typeof window.IntersectionObserver !== 'function') {
			spust(obal);
			continue;
		}
		const io = new window.IntersectionObserver(
			(entries) => {
				for (const e of entries) {
					if (e.isIntersecting) {
						io.disconnect();
						spust(obal);
					}
				}
			},
			{ rootMargin: '300px 0px' }
		);
		io.observe(obal);
	}
	return count;
}
